const langFaq = {
	title: {
		tag: 'faq.title',
		fr: 'FAQ',
		en: 'FAQ',
	},
	subtitle: {
		tag: 'faq.subtitle',
		fr: 'Foire aux questions',
		en: 'Frequently asked questions',
	},
};

export default langFaq;
